<template>
  <div class="table-container have-zoom">
    <div class="layout">
      <h1>会议议程登记</h1>
      <ul>
        <li>活动ID：{{acid}}</li>
        <li>活动标题：{{actionTitle}}</li>
        <li>活动类型：{{actionType}}</li>
        <li>活动城市：{{actionCity}}</li>
        <li>活动时间：{{changeTime(actionTime,'Y')}}</li>
      </ul>
      <el-form ref="form" label-width="80px" class="main-box">
        <template>
          <el-tabs v-model="activeName">
            <el-tab-pane label="AM" name="AM">
              <el-form-item label="演讲时间">
                <el-time-picker is-range v-model="timeList" range-separator="至" start-placeholder="开始时间"
                  end-placeholder="结束时间" placeholder="选择时间范围" value-format="timestamp">
                </el-time-picker>
              </el-form-item>
              <p class="prompt">
                <i class="el-icon-warning"></i>
                注意：
                请先选择结束时间，且开始时间不可晚于结束时间
              </p>
              <el-form-item label="进行活动">
                <el-input size="small" v-model="postAM.doing" placeholder="写了这条通常不写下面三条，写了下面三条就通常不写这条" :maxlength=10></el-input>
              </el-form-item>
              <el-form-item label="演讲主题">
                <el-input size="small" v-model="postAM.title" :maxlength=15 placeholder="最大字数15"></el-input>
              </el-form-item>
              <el-form-item label="演讲嘉宾">
                <el-input size="small" v-model="postAM.guest" :maxlength=10 placeholder="最大字数10"></el-input>
              </el-form-item>
              <el-form-item label="嘉宾头衔">
                <el-input size="small" v-model="postAM.jobTitle" :maxlength=10 placeholder="最大字数10"></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </template>
        <el-form-item>
          <el-button type="primary" @click='pushData' :disabled='!(!postAM.id&&!err)'>添加议程</el-button>
          <el-button type="success" @click='putData' :disabled='!(postAM.id&&!err)'>更新议程</el-button>
          <el-alert title="请从活动列表选择添加议程" type="error" show-icon v-if="err" :closable="false"></el-alert>
        </el-form-item>
      </el-form>
    </div>
    <div class="show-list">
      <h1>会议议程预览</h1>
      <ol>
        <li v-for="(item,index) in originData" :key="index">
          <div class="time">
            <span>{{changeTime(item.startTime,'H')}}</span>-<span>{{changeTime(item.endTime,'H')}}</span>
          </div>
          <p class="doing" :title="item.doing">-{{item.doing}}</p>
          <p class="title" :title="item.title">-{{item.title}}</p>
          <p class="guest" :title="item.guest">-{{item.guest}}</p>
          <p class="jobTitle" :title="item.jobTitle">-{{item.jobTitle}}</p>
          <span class="change" @click='getOneData(item.id)'>修改议程</span>
          <span class="delete" @click='deleteAgenda(item.id)'>删除议程</span>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        disabled: true,
        err: true,
        id: "",
        activeName: "AM",
        actionType: "",
        actionCity: "",
        actionTime: "",
        actionTitle: "",
        timeList: [new Date(0).getTime(), new Date(0).getTime()],
        acid: null,
        type: null,
        postAM: {
          acid: this.acid,
          id: this.id,
          type: null,
          city: null,
          acTime: null,
          doing: null,
          title: null,
          guest: null,
          jobTitle: null,
          startTime: null,
          endTime: null
        },
        originData: null
      };
    },
    watch: {},
    methods: {
      deleteAgenda(id) {
        let type = 'am'
        this.$http.deleteAgenda({
          type,
          id
        }).then(res => {
          if (res.data.statusCode === 200) {
            this.getShowList(this.type, this.acid);
          } else {
            this.$message({
              message: "删除议程失败，请检查网络~",
              type: "err"
            });
          }
        })
      },
      changeTime(tim, type) {
        let time = new Date(tim);
        if (type === "Y") {
          return `${time.getFullYear()}-${time.getMonth()}-${time.getDate()}`;
        }
        if (type === "H") {
          let mi = time.getMinutes();
          if (mi === 0) {
            mi = `00`;
          }
          return `${time.getHours()}:${mi}`;
        }
      },
      initTime() {
        // this.postAM.startTime = this.timeList[0].getTime();
        // this.postAM.endTime = this.timeList[1].getTime();
        this.postAM.startTime = this.timeList[0];
        this.postAM.endTime = this.timeList[1];
      },
      initPostAm() {
        this.postAM.id = null;
        this.postAM.title = null;
        this.postAM.doing = null;
        this.postAM.guest = null;
        this.postAM.jobTitle = null;
        this.postAM.startTime = null;
        this.postAM.endTime = null;
      },
      getOneData(id) {
        this.$http.agenda_detail(this.activeName, id).then(res => {
          if (res.data.statusCode === 200) {
            let {
              acid,
              id,
              type,
              city,
              acTime,
              doing,
              title,
              guest,
              jobTitle,
              startTime,
              endTime
            } = res.data.result;
            this.postAM.acid = this.acid;
            this.postAM.id = id;
            this.postAM.type = type;
            this.postAM.city = city;
            this.postAM.acTime = acTime;
            this.postAM.doing = doing;
            this.postAM.title = title;
            this.postAM.guest = guest;
            this.postAM.jobTitle = jobTitle;
            this.timeList = [startTime, endTime];
            this.postAM.startTime = startTime;
            this.postAM.endTime = endTime;
          } else {
            this.postAM.acid = this.acid;
            this.postAM.id = null;
            this.postAM.type = null;
            this.postAM.city = null;
            this.postAM.acTime = null;
            this.postAM.title = null;
            this.postAM.doing = null;
            this.postAM.guest = null;
            this.postAM.jobTitle = null;
            this.postAM.startTime = null;
            this.postAM.endTime = null;
          }
        });
      },
      pushData() {
        this.initTime();
        this.$http
          .agenda_push({
            dateTime: this.activeName,
            ...this.postAM
          })
          .then(res => {
            if (res.data.statusCode === 200) {
              this.initPostAm();
              this.getShowList(this.type, this.acid);
              this.$message({
                message: "议程添加成功~",
                type: "success"
              });
            } else {
              this.$message.error(res.data.message);
            }
          });
      },
      putData() {
        this.initTime();
        this.$http
          .agenda_put({
            dateTime: this.activeName,
            ...this.postAM
          })
          .then(res => {
            if (res.data.statusCode === 200) {
              this.$router.push(`/agenda/am/post/${this.acid}`);
              this.initPostAm();
              this.getShowList(this.type, this.acid);
              this.$message({
                message: "议程更新成功~",
                type: "success"
              });
            } else {
              this.$message.error(res.data.message);
            }
          });
      },
      getAction() {
        if (this.type === "hkstocks") {
          this.$http.hkstocks_detail(this.acid).then(res => {
            if (res.data.statusCode === 200) {
              const {
                title,
                address,
                startTime,
                type
              } = res.data.result;
              this.actionType = type;
              this.actionCity = address;
              this.actionTime = startTime;
              this.actionTitle = title;
              this.postAM.type = type;
              this.postAM.city = address;
              this.postAM.acTime = startTime;
            } else {
              this.actionType = null;
              this.actionCity = null;
              this.actionTime = null;
              this.actionTitle = null;
              this.postAM.type = null;
              this.postAM.city = null;
              this.postAM.acTime = null;
            }
          });
        } else if (this.type === "freetalks") {
          this.$http.freetalks_detail(this.acid).then(res => {
            if (res.data.statusCode === 200) {
              const {
                title,
                address,
                startTime,
                type
              } = res.data.result;
              this.actionType = type;
              this.actionCity = address;
              this.actionTime = startTime;
              this.actionTitle = title;
              this.postAM.type = type;
              this.postAM.city = address;
              this.postAM.acTime = startTime;
            } else {
              this.actionType = null;
              this.actionCity = null;
              this.actionTime = null;
              this.actionTitle = null;
              this.postAM.type = null;
              this.postAM.city = null;
              this.postAM.acTime = null;
            }
          });
        } else if (this.type === "roadshow") {
          this.$http.roadshow_detail(this.acid).then(res => {
            if (res.data.statusCode === 200) {
              const {
                title,
                address,
                startTime,
                type
              } = res.data.result;
              this.actionType = type;
              this.actionCity = address;
              this.actionTime = startTime;
              this.actionTitle = title;
              this.postAM.type = type;
              this.postAM.city = address;
              this.postAM.acTime = startTime;
            } else {
              this.actionType = null;
              this.actionCity = null;
              this.actionTime = null;
              this.actionTitle = null;
              this.postAM.type = null;
              this.postAM.city = null;
              this.postAM.acTime = null;
            }
          });
        }
      },
      getShowList(type, acid) {
        let acName = this.activeName;
        this.$http.action_agenda_list(this.activeName, type, acid).then(res => {
          if (res.data.statusCode === 200) {
            this.originData = res.data.result;
          } else {
            this.$message.error("数据请求未成功");
          }
        });
      },
      changeTime(tim, type) {
        let time = new Date(tim);
        if (type === "Y") {
          return `${time.getFullYear()}-${time.getMonth()}-${time.getDate()}`;
        }
        if (type === "H") {
          let mi = time.getMinutes();
          if (mi === 0) {
            mi = `00`;
          }
          return `${time.getHours()}:${mi}`;
        }
      }
    },
    created() {
      if (this.$route.params.acid) {
        this.type = this.$route.params.type;
        this.acid = this.$route.params.acid;
        this.id = this.$route.params.id;
        this.postAM.acid = this.acid;
        this.err = false;
        this.disabled = false;
        this.getAction();
        this.getShowList(this.type, this.acid);
        if (this.id) {
          this.postAM.id = this.id;
          this.getOneData(this.id);
        }
      }
    },
    mounted() {
      // if (this.id) {
      //   this.getOneData(this.id);
      // }
    }
  };

</script>

<style scoped>
  .one-line-upload {
    display: inline-block;
    vertical-align: top;
  }

  .table-container>ul>li {
    list-style: none;
    font-size: 14px;
  }

  .main-box {
    width: 500px;
  }

  .am-box {
    margin: 10px;
  }

  .am-box>div {
    margin-bottom: 15px;
    width: 400px;
  }

  .am-box>.el-button {
    margin-left: 12px;
  }

  .am-box:nth-child(2n) {
    background-color: rgb(242, 242, 242);
  }

  .table-container {
    margin-left: 30px;
    display: flex;
    justify-content: space-between;
  }

  li {
    list-style: none;
  }

  .show-list>ol>li {
    border-bottom: 1px solid #ccc;
    padding: 5px;
  }

  .show-list>ol>li>p {
    height: 21px;
  }

  .change {
    color: rgb(36, 120, 255);
    cursor: pointer;
  }

  .delete {
    color: red;
  }

  .prompt {
    /* width: 60%; */
    font-size: 10px;
    text-align: center;
    margin-top: -10px;
    margin-bottom: 10px;
    color: rgb(255, 58, 58);
  }

</style>



// WEBPACK FOOTER //
// src/components/backend/agenda-post.vue